<template>
	<v-col class="history-bonus">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Stock Serial</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-card-bulleted</v-icon>
			<div class="pl-2">Stock Serial</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12">
					<v-card class="pa-3 elevation-0 rounded-lg hover-shadow">
						<v-tabs class="tabs-vo no-slider">
							<v-tab @click="showSerial = 'registrasi'">Serial Registrasi</v-tab>
							<v-tab @click="showSerial = 'aktivasi'">Serial Aktivasi</v-tab>
							<v-tab @click="showSerial = 'upgrade'">Serial Upgrade</v-tab>
							<v-tab @click="showSerial = 'ro'">Serial RO</v-tab>
						</v-tabs>
					</v-card>
				</v-col>
			</v-row>
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="pt-5" v-if="showSerial === 'registrasi'">
					<SerialRegistrasi></SerialRegistrasi>
				</div>
			</v-scroll-x-reverse-transition>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<div class="pt-5" v-if="showSerial === 'aktivasi'">
					<SerialProdukAktivasi></SerialProdukAktivasi>
				</div>
			</v-scroll-x-transition>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<div class="pt-5" v-if="showSerial === 'upgrade'">
					<SerialProdukUpgrade></SerialProdukUpgrade>
				</div>
			</v-scroll-x-transition>
			<v-scroll-x-transition mode="in-out" :hide-on-leave="true">
				<div class="pt-5" v-if="showSerial === 'ro'">
					<SerialProdukRO></SerialProdukRO>
				</div>
			</v-scroll-x-transition>
		</div>
	</v-col>
</template>

<script>
import SerialRegistrasi from './SerialRegistrasi';
import SerialProdukAktivasi from './SerialProdukAktivasi';
import SerialProdukUpgrade from './SerialProdukUpgrade';
import SerialProdukRO from './SerialProdukRO';

export default {
	components: {
		SerialRegistrasi, SerialProdukAktivasi, SerialProdukUpgrade, SerialProdukRO
	},
	data() {
		return {
			showSerial: 'registrasi',
		}
	},
	methods: {
	},
	created(){
		this.$store.dispatch('setPageTitle', `Data Serial`)
	}
};
</script>